module.exports = __webpack_public_path__ + "res/poker.565778a9998229d93931c26b80437925.png";